import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import React from 'react';

const KeypadNum = ({ key, numValue, index, setMobileNumber, showVerifyOTP, setShowNumPad = () => { }, isQwerty, handleToggleKeyboard }) => {
    
    const { ref, focused, onEnterRelease, setFocus } = useFocusable({
        focusKey: key,
        trackChildren: true,
        onArrowPress: (direction) => {
            if (isQwerty) {
                return handleQwertyNavigation(direction);
            } else {
                return handleNumericNavigation(direction);
            }
        },
        onEnterRelease: () => handleKeyPress()
    });

    const handleNumericNavigation = (direction) => {
        if (direction === 'up' && (numValue == '1' || numValue == '2' || numValue == '3')) {
            return false;
        }
        if (direction === 'left' && (numValue == '1' || numValue == '4' || numValue == '7' || numValue == '←')) {
            return false;
        }
        if (direction === 'down' && (numValue === '←' || numValue === '0' || numValue === 'ABC' || numValue === 'x')) {
            setFocus('LOGIN_BUTTON');
            return false;
        }
        return true;
    }

    const handleQwertyNavigation = (direction) => {

        if (direction === 'up') {
            if (index >= 0 && index <= 9) {
                return false;
            }
        }

        if (direction === 'down') {
            if (index >= 30 && index <= 31) {
                setFocus('LOGIN_BUTTON');
                return false;
            }
        }

        if (direction === 'left') {
            if ((index >= 0 && index <= 9 && index === 0) ||       // row 1
                (index >= 10 && index <= 19 && index === 10) ||    // row 2
                (index >= 20 && index <= 29 && index === 20) ||    // row 3
                (index >= 30 && index <= 31 && index === 30)) {    // row 4
                return false;
            }
        }

        return true;
    };

    const handleKeyPress = () => {
        if (numValue === 'ABC' || numValue === '123') {
            handleToggleKeyboard(numValue);
            return;
        }

        if (numValue === 'x') {
            setMobileNumber('');
        } else if (numValue === '←') {
            setMobileNumber(mobileNumber => mobileNumber.slice(0, -1));
        } else {
            setMobileNumber(mobileNumber => {
                if (showVerifyOTP && mobileNumber.length >= 4) return mobileNumber;
                if (!showVerifyOTP && mobileNumber.length >= 50) return mobileNumber;
                return mobileNumber + numValue;
            });
        }
    };

    return (
        <li
            ref={ref}
            className={`keyButton ${focused ? 'active' : ''}`}
            style={{ height: isQwerty && "70px" , width: isQwerty && "55px" }}
            onClick={onEnterRelease}
        >
            {numValue}
        </li>
    );
}

export default KeypadNum;
